<template>
  <transition name="slide-fade">
    <div class="el-panel__wrapper" v-show="visible" :class="`aside-${ aside }`" :style="style">
      <div
        class="el-panel"
        :class="[customClass]"
        ref="panel">
        <div class="el-panel__header">
          <el-toolbar size="large" :title="title" align="left">
            <div slot="right">
              <slot name="action"></slot>
              <div class="bar-item"><el-button class="bar-icon no-hover" icon="el-icon-close" @click="handleClose"></el-button></div>
            </div>
          </el-toolbar>
        </div>

        <el-scrollbar class="el-panel__body"><slot></slot></el-scrollbar>
        <div class="el-panel__footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import event from '@/mixins/event'

export default {
  name: 'ElPanel',
  mixins: [event],
  mounted () {
    this.$event.$on('panel:close', this.handleClose)
  },
  data () {
    return {
    }
  },
  props: {
    width: {
      type: [String, Number],
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    aside: {
      type: String,
      default: 'right'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '64px'
    }
  },
  computed: {
    style () {
      let style = {}
      if (this.width) {
        style.width = this.width
      }
      if (this.top) {
        style.top = this.top
      }
      return style
    }
  },
  methods: {
    handleClose () {
      this.hide()
    },
    hide (cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false)
        this.$emit('close')
        this.closed = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Panel.vue